export default __webpack_public_path__ + "static/media/next.a3efca58.svg";